import styled from 'styled-components';

export const OfferPictureContainer = styled.div`
  position: relative;
  width: 80%;
  max-width: 550px;
  height: 0;
  padding-bottom: 35%;
  margin-bottom: 10px;
  margin-top: 35px;

  ${Styles.desktop`
    width: 70%;
    padding-bottom: 30%;
    margin-top: 81px;
  `}
`;
